<template>
  <div>
    <b-card style="background-color: transparent" border-variant="light">
      <div v-if="!typingCombineFetching && lessonList && lessonList.length">
        <b-container class="bv-example-row">
          <b-row>
            <b-col
              v-for="(lessons, index) in lessonList"
              :key="index"
              lg="3"
              md="6"
              sm="12"
              class="eachCard"
            >
              <TypingCombineLessonCard :lessons="lessons" />
            </b-col>
          </b-row>
        </b-container>
        <!-- <b-card-footer>
          <b-progress striped animated :max="100" height="2rem">
            <b-progress-bar :value="completeRate">
              <strong>{{ completeRate }}%</strong>
            </b-progress-bar>
          </b-progress>
        </b-card-footer>-->
      </div>
      <div v-else>
        <b-spinner variant="success" type="grow" label="Spinning"></b-spinner>
      </div>
    </b-card>
  </div>
</template>

<script lang='js'>
import Vue from 'vue'
import { mapState } from 'vuex'
import TypingCombineLessonCard from '@/components/Typing/TypingCombine/TypingCombineLessonCard.vue'

const TypingCombineLessonList = Vue.extend({
  name: 'TypingCombineLessonList',
  components: {
    TypingCombineLessonCard
  },
  mounted () {
    this.$store.dispatch('typing/fetchTypingCombineLessonLists')
      .then((response) => {
        if (response === 'OK') {
          this.preprocess()
        }
      })
  },
  data () {
    return {
      lessonList: []
    }
  },
  computed: {
    ...mapState({
      typingCombineFetching: state => state.typing.typingCombineFetching,
      typingCombineLessonList: state => state.typing.typingCombineLessonList,
      currentUser: state => state.auth.currentUser
    })
  },
  methods: {
    preprocess () {
      let combinedList = []
      let toShowDescription = false
      // let completedCount = 0
      for (let i = 0; i < this.typingCombineLessonList.combineIntermediateLessons.length; i++) {
        this.typingCombineLessonList.combineIntermediateLessons[i].showDescription = false
        this.typingCombineLessonList.combineAdvancedLessons[i].showDescription = false
        if (Number(this.currentUser.gradeId) === 1) {
          this.typingCombineLessonList.combineIntermediateLessons[i].showDescription = true
          this.typingCombineLessonList.combineAdvancedLessons[i].showDescription = true
          combinedList.push([
            this.typingCombineLessonList.combineIntermediateLessons[i],
            this.typingCombineLessonList.combineAdvancedLessons[i]
          ])
          continue
        }

        if (!toShowDescription) {
          if (!this.typingCombineLessonList.combineIntermediateLessons[i].locked && this.typingCombineLessonList.combineAdvancedLessons[i].locked) {
            /** 如果當前的進階沒鎖，而當前的精進有鎖，則當前的進階顯示說明 */
            this.typingCombineLessonList.combineIntermediateLessons[i].showDescription = true
            toShowDescription = true
          } else if (i + 1 < this.typingCombineLessonList.combineIntermediateLessons.length &&
          !this.typingCombineLessonList.combineAdvancedLessons[i].locked && this.typingCombineLessonList.combineIntermediateLessons[i + 1].locked) {
            /** 如果當前的精進沒鎖，而下一個進階有鎖，則當前的精進顯示說明 */
            this.typingCombineLessonList.combineAdvancedLessons[i].showDescription = true
            toShowDescription = true
          }
        }

        combinedList.push([
          this.typingCombineLessonList.combineIntermediateLessons[i],
          this.typingCombineLessonList.combineAdvancedLessons[i]
        ])
      }
      this.lessonList = combinedList

      // roundDecimal((completed / (this.combinedList.length * 3)) * 100, 2)
    }
  }
})

export default TypingCombineLessonList
</script>

<style lang='scss' scoped>
@import "../styles/lessonCardStyles.scss";
</style>
